<template>
  <app-list
    :loading="loading"
    :alert-message="alertMessage"
    :show-alert.sync="showAlert"
    :alert-type="alertType"
    :go-to-single-item="goToSingleItem"
    :items="filteredUsers"
    :pageNumber="pageNumber"
    :updatePageNumber="SET_PAGE_NUMBER"
    :displayMenu=true
  >
    <template v-slot:action-buttons>
      <v-btn
        :to="{ name: 'check-in-sheet-add' }"
        class="text-none"
      >
        <v-icon class="mr-2">mdi-plus</v-icon>
        Create check-in sheet
      </v-btn>
      <v-btn
        :to="{ name: 'user-add' }"
        class="text-none"
      >
        <v-icon class="mr-2">mdi-plus</v-icon>
        Add a User
      </v-btn>
    </template>
    <template v-slot:search-box>
      <v-text-field
        placeholder="Search"
        class="user-list__search white"
        v-model.lazy="search"
        append-icon="mdi-magnify"
        hide-details
        outlined
        dense
      />
    </template>

    <template v-slot:menu-options="{ item }">
      <v-list-item
        @click="$router.push({ name: 'user-edit', params: { id: item.id } })"
        dense
      >
        <v-list-item-title>Edit</v-list-item-title>
      </v-list-item>
      <v-divider />
      <v-list-item
        @click.prevent="freezePrice(item.id)"
        dense
      >
        <v-list-item-title>{{ item.fixed_metals_prices ? "Un-freeze Price" : "Freeze Price" }}</v-list-item-title>
      </v-list-item>
      <v-divider />
      <v-list-item
        @click="deleteUser(item.id, item.contact_person)"
        dense
      >
        <v-list-item-title class="red--text">Delete</v-list-item-title>
      </v-list-item>
    </template>
    <template v-slot:app-item="{ item }">
      <span class="pb-2 font-weight-black text-h6">{{ item.company_name }}</span>
      <span class="pb-2 black--text">Contact Person: {{ item.contact_person }}</span>
      <span class="black--text">Location: {{ item.location }} </span>
    </template>
  </app-list>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from "@/store/modules/user";
import { mapGetters as preciousMetalsGetters } from "@/store/modules/preciousMetals";
import { extractDataAxios, extractErrorMessageAxios } from "@/httpClient";
import AppList from "@/components/AppList.vue";
export default {
  name: "UserList",
  async mounted() {
    await this.fetchAllUsers();
  },
  data() {
    return {
      search: "",
      alertType: null,
      showAlert: false,
      alertMessage: "",
    };
  },
  watch: {
    showAlert(val) {
      if (val === false) {
        this.alertMessage = "";
        this.alertType = null;
      }
    },
  },
  components: {
    AppList,
  },
  methods: {
    ...mapActions(["fetchAllUsers", "removeUser"]),
    ...mapMutations(["SET_PAGE_NUMBER"]),
    async deleteUser(userId, contactName) {
      if (userId === this.user.id) {
        this.displayAlert("warning", "User cannot delete themselves!");
        return;
      }
      if (window.confirm(`Are you sure that you want to delete ${contactName}?`)) {
        try {
          const deleteUserResponse = await this.removeUser(userId);
          this.displayAlert("success", deleteUserResponse);
        } catch (err) {
          this.displayAlert("error", extractErrorMessageAxios(err));
        }
      }
    },
    async freezePrice(userId) {
      try {
        const user = this.users.find((user) => user.id === userId);
        let fixedPrice = null;
        if (!user.fixed_metals_prices) {
          fixedPrice = Object.assign({}, this.createFixedPriceObject());
        }
        const updatedUser = extractDataAxios(
          await window.axios.put(`/api/user/${userId}/update/frozen-price`, fixedPrice)
        );
        this.$store.commit("user/UPDATE_SINGLE_USER", updatedUser);
        this.displayAlert("success", "Successfully updated user price!");
      } catch (err) {
        this.displayAlert("error", extractErrorMessageAxios(err));
      }
    },
    goToSingleItem(userID) {
      this.$router.push({ name: "single-user", params: { id: userID } });
    },
    createFixedPriceObject() {
      return { platinum: this.pricesArray[0], palladium: this.pricesArray[1], rhodium: this.pricesArray[2] };
    },
    displayAlert(type, message) {
      this.alertType = type;
      this.alertMessage = message;
      this.showAlert = true;
    },
  },
  computed: {
    ...mapGetters(["users"]),
    ...mapState({
      loading: (state) => state.isLoading,
      user: (state) => state.user,
      pageNumber: (state) => state.pageNumber,
    }),
    ...preciousMetalsGetters(["pricesArray"]),
    filteredUsers() {
      const _self = this;
      if (this.search) {
        const users = this.users.filter(function (user) {
          const userValues = Object.values(user);
          return userValues.find((dataPoint) => {
            //values could be null
            if (dataPoint) {
              return dataPoint.toString().toLowerCase().includes(_self.search.toLowerCase());
            }
          });
        });
        return users;
      }
      return this.users;
    },
  },
};
</script>

<style scoped>
.user-list__card {
  height: 100%;
}
.user-list__buttons {
  display: grid;
  grid-auto-flow: column;
  grid-template-columns: auto auto 1fr;
  gap: 10px;
}
.user-list__search {
  width: 300px;
  justify-self: end;
}
.row.user-list__row {
  width: 80%;
  margin: auto;
}
.user-list__name,
.user-list__company,
.user-list__location {
  justify-content: center;
}
.user-list__details {
  max-width: 400px;
  margin: auto;
}
.user-list__options {
  position: absolute;
  right: 0;
}
</style>
